/*=============================
=             Hero            =
=============================*/

var slidesContainer = document.getElementById('slides');

if(slidesContainer) {
    var slides = slidesContainer.querySelectorAll('li'),
        heroControls = document.getElementById('hero-controls'),
        playPauseHero = heroControls.firstElementChild,
        bullets = [].slice.call(heroControls.querySelectorAll('li button')),
        currentBullet = 0,
        heroTimeout,
        runHero = function() {
            currentBullet = (currentBullet + 1) % bullets.length;
            toggleBullets(bullets[currentBullet]);
            startSlide(false);
        };

    setTimeout(startSlide, 0);

    bullets.forEach(function(bullet) {
        bullet.addEventListener('click', function() {
            clearTimeout(heroTimeout);

            toggleBullets(this);
            currentBullet = bullets.indexOf(bullet);
            startSlide(true);
        });
    });

    playPauseHero.addEventListener('click', function() {
        var isPlay = this.classList.contains('play');

        if(isPlay)
            heroTimeout = setTimeout(runHero, 1500);
        else
            clearTimeout(heroTimeout);

        this.className = isPlay ? 'pause' : 'play';
        this.setAttribute('aria-label', (isPlay ? 'Pause' : 'Play')+' Hero');
    });
}

function startSlide(click) {
    var currentSlide = slidesContainer.querySelector('.current');

    if(slidesContainer.classList.contains('with-animation')) {
        [].slice.call(slidesContainer.querySelectorAll('li:not(.current)')).forEach(function(slide) {
            slide.querySelector('div.title').setAttribute('style', '');
            slide.querySelector('p').setAttribute('style', '');
        });

        setTransition(currentSlide.querySelector('div.title'), currentSlide.querySelectorAll('p'), click);
    }

    if(playPauseHero.classList.contains('pause'))
        heroTimeout = setTimeout(runHero, 7500);
}
function toggleBullets(bullet) {
    var bulletIndex = bullets.indexOf(bullet);

    document.querySelector('#hero-controls .current').classList.remove('current');
    slidesContainer.querySelector('li.current').classList.remove('current');

    slides[bulletIndex].classList.add('current');

    bullet.classList.add('current');
}

function setTransition(title, text, click) {
    setTimeout(function() {
        title.setAttribute('style', 'opacity: 1; transform: none;'+(click ? ' transition: opacity .2s' : ''));
    }, (click ? 100 : 900));

    Velocity(text, {opacity: [1,0]}, (click ? {duration: 200} : {duration: 300, delay: 1700}));
}
